import { environment } from "environments/environment";
import { CompanyConfig } from "../interfaces/company-config.interface";

export const COMPANY_CONFIG: CompanyConfig = {
  name: environment.companyConfig.name,
  socialMediaName: environment.companyConfig.socialMediaName,
  email: environment.companyConfig.email,
  rtn: environment.companyConfig.rtn,
  watermark: environment.companyConfig.watermark,
  blackLettersLogo: environment.companyConfig.blackLettersLogo,
  oneLineBlackLettersLogo: environment.companyConfig.oneLineBlackLettersLogo,
  quoteGroupLogo: environment.companyConfig.quoteGroupLogo,
  quoteLogo: environment.companyConfig.quoteLogo,
  virtualSign: environment.companyConfig.virtualSign,
  quoteParkingClause: environment.companyConfig.quoteParkingClause,
  quoteParkingInRooms: environment.companyConfig.quoteParkingInRooms,
  quoteRooms: environment.companyConfig.quoteRooms,
};
